import React from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../redux/ReduxType";

export interface ILink {
  Title: string;
  Logo?: React.ReactNode;
  link?: string;
  isDark?: boolean;
  isActive?: boolean;
  onClick?: () => void;
}

const ListLink: React.FC<ILink> = ({
  Logo,
  Title,
  link,
  isDark,
  isActive,
  onClick,
}) => {
  const themeDark = useAppSelector((state) => state.theme.isDark);
  const effectiveIsDark = isDark !== undefined ? isDark : themeDark;

  return (
    <li className="w-full">
      <Link
        to={`/${link}`}
        onClick={onClick}
        className={`flex items-center gap-3 px-4 py-2 rounded-md text-sm transition-colors duration-200 w-full ${
          isActive
            ? effectiveIsDark
              ? "bg-gray-700 text-indigo-400"
              : "bg-gray-100 text-indigo-600"
            : effectiveIsDark
            ? "text-gray-300 hover:bg-gray-700 hover:text-white"
            : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
        } ${Title === "More" ? "sm:hidden" : ""}`}
        aria-label={Title}
      >
        {Logo && <span className="flex-shrink-0">{Logo}</span>}
        <span className="truncate">{Title}</span>
      </Link>
    </li>
  );
};

export default ListLink;
